import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useRouteError } from 'react-router-dom'
import Navigation from '../Components/Navigation/Navigation'
import Section from '../Components/Elements/Section'

export default function ErrorPage () {
  const { t } = useTranslation(['common', 'login'])
  const error = useRouteError()

  if (error === 401) {
    return <Navigate to='/login' replace state={{ message: t('login:redirectMessage') }} />
  }

  return (
    <div className='relative bg-white min-h-screen'>
      <Navigation />
      <Section background='cyan'>
        <div className="self-center text-xl font-light text-gray-600 sm:text-2xl">
          {t('common:error.heading')}
        </div>
        <p>{t('common:error.body', { error: error.statusText || error.message })}</p>
      </Section>
    </div>
  )
}
